import React, { FC } from "react";
import { COLOR_BLACK } from "../colors";
import { IconType } from "./types";

export const ReplayIcon: FC<IconType> = ({
  color = COLOR_BLACK,
  size = 24,
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 5V2.21C12 1.76 11.46 1.54 11.15 1.86L7.35003 5.65C7.15003 5.85 7.15003 6.16 7.35003 6.36L11.14 10.15C11.46 10.46 12 10.24 12 9.79V7C15.73 7 18.68 10.42 17.86 14.29C17.39 16.56 15.55 18.39 13.29 18.86C9.72003 19.61 6.54003 17.16 6.06003 13.85C5.99003 13.37 5.57003 13 5.08003 13C4.48003 13 4.00003 13.53 4.08003 14.13C4.70003 18.52 8.88003 21.77 13.61 20.85C16.73 20.24 19.24 17.73 19.85 14.61C20.84 9.48 16.94 5 12 5Z"
      fill={color}
    />
  </svg>
);
